<li class="pill" [ngClass]="{'active': is_active}" (click)="showContent()">
	<a class="icon-Shape-4">upperClub Branded Rules</a>
</li>

<a class="icon-Shape-4 pill-mobile" [ngClass]="{'active': show_mobile}" (click)="showMobileContent()">upperClub Branded Rules</a>
<div class="tab-pane" *ngIf="show_content || show_mobile" [ngClass]="{'show': show_mobile}" id="item-3">

	<h2 class="titulo-intro" (click)="toggleClass('1')" [ngClass]="{'open': show_description1}">upperClub Branded Rules – Fly and Stay Care Experiences</h2>

	<div class="container" [ngClass]="{'show': show_description1}">
		<p class="italic">
			The following <strong>upperClub</strong> Branded Rules only apply when your redemption / purchase is
			done <span>with rewards only or when combining rewards and card on file.</span>
		</p>
		<p>
			<strong>Trip Cancellation</strong><br>
			You will be compensated when the airline cancels your flight or if you must cancel your trip in
			your country of origin for &quot;any reason”; up to value of the penalty and / or difference of a new
			ticket.
		</p>
		<p>
			<strong>Trip Interruption</strong><br>
			You will be covered for travel expenses related to transportation and accommodations of your
			incomplete <strong>Scheduled Trip</strong>; up to value of the penalty and / or difference of a new ticket.
		</p>
		<p>
			<strong>International Loss Connection</strong><br>
			You will be placed in another flight with same conditions if you lose your international
			connection.
		</p>
		<p>
			<strong>Delayed Flight</strong><br>
			You will be compensated if your international connection flight is delayed for more than 6 hours
			for up to US$ 100.
		</p>
		<p>
			<strong>Loss and Delayed Baggage</strong><br>
			You will receive a benefit if your luggage is confirmed lost or does not arrive on time at your
			travel destination; US$ 200 compensation per day for up to 2 days when delayed and US$ 600
			compensation when lost.
		</p>
		<p>
			<strong>Emergency Medical Expenses</strong><br>
			You will be covered for up to US$ 50,000 for emergency medical expenses while traveling
			including hospitalization, dental treatment, drugs prescription and hotel expenses if you need to
			extend your stay, amongst others.
		</p>
		<p>
			<strong>Personal Travel Devices</strong><br>
			We will cover the value or repair your devices - such as mobile/smart phones, tablets, laptops,
			smart watches, among others - if they are lost, stolen, damaged or destroyed for up to US$ 500.
		</p>
	</div>




	<h2 (click)="toggleClass('2')" [ngClass]="{'open': show_description2}">TRIP CANCELLATION – up to the value of penalty or difference of new ticket</h2>

	<div class="container" [ngClass]="{'show': show_description2}">
		<p>
			<strong>The Experience:</strong><br>
			Members contact <strong>upperClub</strong> leveraging our interactive contact tool, via preferred channel such
			as chat, voice or video, to submit required documentation/proof of flight cancellation. <strong>upperClub</strong>
			will offer members support in any rebooking activity, if preferred.
		</p>
		<p>
			<strong>Terms and Conditions:</strong><br>
			Subject to the Deductible and Limits stated in the Schedule of <strong>Benefits</strong> and Limits, <strong>upperClub</strong>
			will pay the following expenses incurred by a <strong>Covered Person</strong> during a <strong>Covered Trip</strong>.
		</p>
		<p>
			<strong>upperClub</strong> will pay for unused non-refundable prepaid expenses for travel transportation and
			accommodation up to US$2,000 or the cost of the <strong>Covered Person’s</strong> paid airline ticket, whichever
			is less, whenever the <strong>Covered Perso</strong> is prevented from taking a scheduled Trip for any of the
			following reasons that occur after the start of the period:
		</p>
		<ul class="number">
			<li>Specified Illness, <strong>Injury or death</strong> of the <strong>Covered Person</strong>, their traveling companion, business
				partner or <strong>Family member</strong> of either the <strong>Covered Person</strong> or their traveling companion that
				results in medically imposed restrictions as certified by a legally qualified <strong>Physician</strong> at the time
				of loss, preventing the <strong>Covered Person’s</strong> continued participation in the <strong>Scheduled Trip</strong>.
			</li>
			<li>
				Weather that causes complete cessation of services of the <strong>Covered Person’s</strong> common carrier
				for at least 48 consecutive hours.
			</li>
			<li>
				Employer termination or layoff affecting the <strong>Covered Person</strong> or a person sharing the same
				room. Employment must have been with the same employer for at least three continuous years.
			</li>
			<li>
				Terrorism. The <strong>Act of Terrorism</strong> must occur in a city listed on the <strong>Covered Person’s</strong> itinerary
				within 30 days prior to the scheduled departure date. This same city must not have experienced
				an <strong>Act of Terrorism</strong> within the 90 days prior to the <strong>Act of Terrorism</strong>, which is causing the
				<strong>Covered Person’s</strong> cancellation. <strong>Benefits</strong> are not provided if the <strong>Covered Person’s</strong> travel
				supplier offers a substitute itinerary.
			</li>
			<li>
				Hijack, quarantine, jury duty or court ordered appearance as a witness in a legal action in which
				the <strong>Covered Person</strong> or their traveling companion are not a party (except law enforcement
				officers).
			</li>
			<li>
				Primary residence of the <strong>Covered Person</strong> or their traveling companion is rendered
				uninhabitable due to unforeseen circumstances.
			</li>
			<li>
				Traffic accident directly involving either the <strong>Covered Person</strong> or their traveling companion,
				substantiated by a police report, while en route to a scheduled departure point.	
			</li>
			<li>
				If the <strong>Covered Person’s</strong> travel supplier cancels their <strong>Scheduled Trip</strong>, the <strong>Covered Person</strong> will receive up to US$ 75 for the reissue fee charged by the airline for their tickets. The Covered
				Person must cover the full cost of the <strong>trip</strong>.
			</li>
		</ul>

		<p>
			<strong>upperClub</strong> will also pay up to US$2,000 or 75%, whichever is less, for unused non-refundable
			prepaid expenses for travel transportation and accommodation or the cost of the Covered
			Person’s paid airline ticket if the <strong>Covered Person</strong> chooses not to take a <strong>Scheduled Trip</strong> for
			any other reason that occurs during the Membership Period.
		</p>


		<p>Conditions and Restrictions:</p>
		<ul class="text-capital">
			<li>						
				All cancellations must be reported to the travel supplier and to the <strong>Claims Administrator</strong> within
				72 hours of the event causing the need to cancel or the day of departure. If the event delays the
				reporting of the cancellation beyond the 72 hours, report the event as soon as possible.
			</li>
		</ul>
		
	</div>

	<h2 (click)="toggleClass('3')" [ngClass]="{'open': show_description3}">TRIP INTERRUPTION – up to the value of penalty or difference of new ticket</h2>

	<div class="container" [ngClass]="{'show': show_description3}">
		<p>
			<strong>The Experience:</strong><br>
			Members contact <strong>upperClub</strong> leveraging our interactive contact tool, via preferred channel such
			as chat, voice or video, to submit required documentation. <strong>upperClub</strong> will offer members
			support in any rebooking activity, if preferred.
		</p>
		<p>
			<strong>Terms and Conditions:</strong><br>
			Trip Interruption – <strong>upperClub</strong> will pay the following Trip Interruption expenses if, during a
			covered <strong>Trip</strong> there is an unexpected death of the <strong>Covered Person</strong>&#39;s travel companion or
			immediate family member (<strong>Eligible Spouse</strong>, child, parent or sibling), provided such expenses
			are approved in advance and arranged by <strong>upperClub</strong>:
		</p>
		<ul class="point">
			<li>
				The cost of a one-way air or ground transportation ticket of the same class as the unused travel ticket, less the value of the unused return ticket, for the <strong>Covered Person</strong>.
				<p>
					Trip Interruption - If the <strong>Covered Person</strong> is prevented from completing a <strong>Scheduled Trip</strong> for
					any of the reasons listed under the Trip Cancellation section that occurs after the start of the
					Membership Period and after the departure date of the <strong>Scheduled Trip</strong>, the <strong>Covered Person</strong> is
					eligible up to specified amounts:
				</p>
			</li>
			<li>
				Any unused non-refundable prepaid expenses for Travel Arrangements;
			</li>
			<li>
				Return air: One-way Transportation to return to your original destination or rejoin your Trip less
				the value of the original unused return travel ticket;
			</li>
			<li>
				Accommodations and transportation expenses for up to US$ 150 per day for 10 additional days
				when a Traveling Companion must remain hospitalized or an <strong>Injury</strong> or <strong>Illness</strong> not requiring
				hospitalization prevents you from continuing travel and you must extend your Trip with
				additional hotel nights due to medically imposed restrictions on a Traveling Companion as
				certified by a Legally Qualified <strong>Physician</strong>.
			</li>
			<li>
				Single supplement upgrade – the <strong>Covered Person</strong> is eligible for <strong>Benefits</strong> when their traveling
				companion cancels or interrupts a trip for a specified reason and the <strong>Covered Person</strong> does not.
			</li>
		</ul>
	</div>





	<h2 (click)="toggleClass('4')" [ngClass]="{'open': show_description4}">INTERNATIONAL LOSS CONNECTION</h2>

	<div class="container" [ngClass]="{'show': show_description4}">
		<p>
			<strong>The Experience:</strong><br>
			Members contact <strong>upperClub</strong> leveraging our interactive contact tool, via preferred channel such
			as chat, voice or video, to submit required documentation/proof of flight cancellation. <strong>upperClub</strong>
			will offer members support in any rebooking activity, if preferred.
		</p>
		<p>
			<strong>Terms and Conditions:</strong><br>
			If the <strong>Covered Person</strong> loses their international connection flight, they will be placed on another
			flight with the same conditions as the initial flight.
		</p>
	</div>



	<h2 (click)="toggleClass('5')" [ngClass]="{'open': show_description5}">DELAYED FLIGHT – up to US$ 100</h2>

	<div class="container" [ngClass]="{'show': show_description5}">
		<p>
			<strong>The Experience:</strong><br>
			Members contact <strong>upperClub</strong> leveraging our interactive contact tool, via preferred channel such
			as chat, voice or video, to submit required documentation/proof of flight cancellation. <strong>upperClub</strong>
			will offer members support in any rebooking activity, if preferred.
		</p>
		<p>
			<strong>Terms and Conditions:</strong><br>
			If the <strong>Covered Person’s</strong> international connection flight is delayed for more than 6 hours, they
			will be re-booked, or a credit will be issued with the value of the compensation up to the product
			specified amounts.
		</p>
	</div>



	<h2 (click)="toggleClass('6')" [ngClass]="{'open': show_description6}">LOSS AND DELAYED BAGGAGE – US$ 200 per day for up to 2 days when delayed and
		US$ 600 when lost</h2>

	<div class="container" [ngClass]="{'show': show_description6}">
		<p>
			<strong>The Experience:</strong><br>
			Members contact <strong>upperClub</strong> leveraging our interactive contact tool, via preferred channel such
			as chat, voice or video, to submit required airline’s Property Irregularity Report (PIR).
		</p>
		<p>
			<strong>Terms and Conditions:</strong><br>
			Subject to the Deductible and Limits stated in the Schedule of <strong>Benefits</strong> and Limits, <strong>upperClub</strong>
			will pay the following expenses incurred by a <strong>Covered Person</strong> during a covered <strong>Trip</strong>.
		</p>
		<p>
			If the <strong>Covered Person’s</strong> luggage is delayed will receive upon PIR (Property Irregularity Report)
			being provided, a compensation up to US$ 200 per day for up to 2 days. If luggage is confirmed
			lost, <strong>Covered Person</strong> receive the value of the compensation of US$ 600 upon receipt of the
			certification provided by the airline.
		</p>
	</div>



	<h2 (click)="toggleClass('7')" [ngClass]="{'open': show_description7}">EMERGENCY MEDICAL EXPENSES – up to US$ 50,000</h2>

	<div class="container" [ngClass]="{'show': show_description7}">
		<p>
			Subject to the Deductible and Limits stated in the Schedule of <strong>Benefits</strong> and Limits, <strong>upperClub</strong>
			will pay the following expenses incurred by a <strong>Covered Person</strong> during a covered <strong>Trip</strong>:
		</p>

		<ul class="number">
			<li>
				Charges made by a <strong>Hospital</strong> for:
				<ul class="text-normal">
					<li>
						Daily room and board and nursing services not to exceed the <strong>Hospital&#39;s</strong> average semi-private room rate; and
					</li>
					<li>
						Daily room and board and nursing services in <strong>Intensive Care Unit;</strong> and
					</li>
					<li>
						Use of operating, treatment or recovery room; and services and supplies which are routinely
						provided by the <strong>Hospital</strong> to persons for use while <strong>Inpatients</strong>, with the exception of personal
						services and supplies of a non-medical nature; and
					</li>
					<li>
					<strong>Emergency Room</strong> treatment of an <strong>Injury</strong> due to an <strong>Accident</strong>; and
					</li>

					<li>
					<strong>Emergency Room</strong> treatment of an <strong>Illness</strong> resulting in admission to the <strong>Hospital</strong> as an
						Inpatient for further treatment of that Illness; and 
					</li>
					<li>
						<strong>Emergency Room</strong> treatment of an Illness
						which does not result in admission to the <strong>Hospital</strong> as an Inpatient, if non-Emergency Room
						care was not available due to the time or location of the <strong>Covered Person</strong> at the onset of
						symptoms.
					</li>
					
				</ul>
			</li>
			<li>
				For <strong>Surgery</strong> at an <strong>Outpatient Surgical</strong> facility, including services and supplies.
			</li>
			<li>
				For charges made by a Physician for professional services, including <strong>Surgery</strong>. Charges for an
				assistant surgeon are covered up to 20% of the <strong>Usual, Reasonable and Customary</strong> charge of
				the primary surgeon, but standby availability will not be deemed a professional service and
				therefore is not covered hereunder. Professional charges for providing a Second Medical
				Opinion are covered, including reasonable expenses for compilation of documentation, official
				translations, shipment of documents and verification of clinical history.
			</li>
			<li>
				For dressings, sutures, casts or other supplies which are <strong>Medically Necessary</strong> and
				administered by or under the supervision of a <strong>Physician</strong>, but excluding nebulizers, oxygen
				tanks, diabetic supplies, other supplies for use or application at home, and all devices or
				supplies for repeat use at home, except <strong>Durable Medical Equipment</strong> as herein defined.
			</li>


			<li>
				For diagnostic testing using radiology, ultrasonographic or laboratory services (psychometric,
				intelligence, behavioral and educational testing are not included).
			</li>
			<li>
				For reconstructive <strong>Surgery</strong> that takes place while this coverage is in effect when the
				reconstructive <strong>Surgery</strong> is directly related to an <strong>Accident</strong> which also takes place while this
				coverage is in effect.
			</li>
			<li>
				For hemodialysis and the charges by the <strong>Hospital</strong> for processing and administration of blood or
				blood components but not the cost of the actual blood or blood components.
			</li>
			<li>
				For oxygen and other gasses and their administration by or under the supervision of a
			<strong>Physician</strong>.
			</li>
			<li>
				For anesthetics and their administration by a <strong>Physician</strong> or anesthetist.
			</li>
			<li>
				For drugs which require prescription by a <strong>Physician</strong> for treatment of a covered <strong>Injury</strong> or
				Illness, but not for the replacement of lost, stolen, damaged, expired or otherwise compromised
				drugs, subject to a maximum supply of thirty (30) days per prescription and the Limit stated in
				the Schedule of <strong>Benefits</strong> and Limits.
			</li>
			<li>
				For care in a licensed <strong>Extended Care Facility</strong> upon direct transfer from an acute care
			<strong>Hospital</strong>.
			</li>
			<li>
				Home Nursing Care in bed by a qualified licensed professional, provided by a Home Health
				Care Agency upon direct transfer from an acute care <strong>Hospital</strong> and only in lieu of <strong>Medically
				Necessary Inpatient</strong> hospitalization.
			</li>
			<li>
				For charges made by a Physician for professional services or by a Hospital cause of SARS-CoV-2 (Covid-19) included:
				<ul class="text-normal">
					<li>
						Test necessary for the diagnosis of the pathology (Not considered a research
						exam)
					</li>
					<li>
						daily room and board and nursing services not to exceed the Hospital&#39;s average semi-private room rate; and
					</li>
					<li>
						daily room and board and nursing services in Intensive Care Unit; and
					</li>
					<li>
						treatment or recovery room; and services and supplies which are routinely provided by the Hospital to persons for use while Inpatients, except for personal services and supplies of a non-medical nature; and
					</li>
					<li>
						Emergency Room treatment of an Illness resulting in admission to the Hospital as an Inpatient for further treatment of that Illness.
					</li>
				</ul>
			</li>	
			<li>
				Emergency Local Ambulance transport necessarily incurred in connection with <strong>Injury or Illness</strong>
				resulting in Inpatient hospitalization.
			</li>
			<li>
			<strong>Dental Treatment</strong> necessary to restore or replace sound natural teeth lost or damaged in an
				Accident which was covered under this cover, up to the Limit stated in the Schedule of <strong>Benefits</strong>
				and Limits.
			</li>
			<li>
			<strong>Dental Treatment</strong> necessary to resolve sudden onset of acute pain, up to the Limit stated in the
				Schedule of <strong>Benefits</strong> and Limits.
			</li>
			<li>
			<strong>Medically Necessary</strong> rental of <strong>Durable Medical Equipment</strong> (consisting of a standard basic
		<strong>Hospital</strong> bed and or a standard basic wheelchair) up to the purchase prices.
			</li>
			<li>
				Physical therapy by a licensed physiotherapist necessarily incurred to continue recovery from a
				covered Injury or Illness. Such physical therapy must be prescribed by a <strong>Physician</strong> who is not
				affiliated with the physiotherapy practice performing the physical therapy.
			</li>
			<li>
				Emergency Medical Evacuation: Subject to the Conditions and Restrictions contained in this
				provision, <strong>upperClub</strong> will pay the following expenses arising out of Emergency Medical
				Evacuation, provided such expenses are approved in advance and arranged by <strong>upperClub</strong>:
				<ul class="number">
					<li>
					<strong>Emergency</strong> air transportation to a suitable airport nearest to the <strong>Hospital</strong> where the Covered
						Person will receive treatment; and
					</li>
					<li>
					<strong>Emergency</strong> ground transportation necessarily preceding Emergency air transportation; and
						from the destination airport to the Hospital where the <strong>Covered Person</strong> will receive treatment.
					</li>
					<li>
						The cost of an economy one-way air and/or ground transportation ticket for the Covered
						Person from the area where the <strong>Covered Person</strong> was hospitalized following an Emergency
						Medical Evacuation to the area where the <strong>Covered Person</strong> was initially evacuated from, or to
						the terminal serving the area of the <strong>Covered Person</strong>&#39;s <strong>Principal Residence</strong>.
					</li>
				</ul>
			</li>
		</ul>

		<p>
			Conditions and Restrictions:
		</p>

		<ul class="text-capital">
			<li>
				<strong>upperClub</strong> will provide <strong>Emergency</strong> Medical Evacuation <strong>Benefits</strong> only when the <strong>Illness</strong> or
				Injury giving rise to the <strong>Emergency</strong> Medical Evacuation is covered under this cover; and
			</li>
			<li>
				<strong>upperClub</strong> will provide <strong>Emergency</strong> Medical Evacuation <strong>Benefits</strong> only when all of the following
				conditions are met:
				<p>
					Medically Necessary treatment, services and supplies cannot be provided locally; and
				</p>

				<ul class="number-roman">
					<li>
						transportation by any other method would result in loss of the <strong>Covered Person</strong>&#39;s life or
					</li>
					<li>
						Loss of limb that could give rise to the loss of the <strong>Covered Person</strong>&#39;s life; and
					</li>
					<li>
						recommended by the attending <strong>Physician</strong> who certifies to the above; and
					</li>
					<li>
						agreed upon by the <strong>Covered Person</strong> or a Relative of the <strong>Covered Person</strong>;
					</li>
					<li>
						the condition giving rise to the <strong>Emergency</strong> Medical Evacuation occurred spontaneously and
						without advance warning, either in the form of <strong>Physician</strong> recommendation or symptoms which
						would have caused a prudent person to seek medical attention prior to the onset of the
						Emergency
					</li>
				</ul>
			</li>
			<li>
				<strong>upperClub</strong> will provide <strong>Emergency</strong> Medical Evacuation only to the nearest Hospital that is
				qualified to provide the Medically Necessary treatment, services and supplies to prevent the
				<strong>Covered Person</strong>&#39;s loss of life or loss of limb that could give rise to the loss of the Covered
				Person&#39;s life.
			</li>
			<li>
				<strong>upperClub</strong> will use their best efforts to arrange any <strong>Emergency</strong> Medical Evacuation within the
				least amount of time possible. The <strong>Covered Person</strong> understands that the timeliness of
				Emergency Medical Evacuation can be affected by circumstances which are not within the
				control of <strong>upperClub</strong> including but not limited to availability of transportation equipment and
				staff, delays or restrictions on flights caused by mechanical problems, government officials,
				telecommunications problems and weather. The <strong>Covered Person</strong> agrees to hold <strong>upperClub</strong> harmless and <strong>upperClub</strong> shall not be held liable for any delays that are not within their direct
				and immediate control. Notwithstanding the foregoing items B. i.-v. and C., <strong>upperClub</strong> will pay
				for expenses to return the <strong>Covered Person</strong> to their Home Country if the attending <strong>Physician</strong>,
				the <strong>Covered Person</strong> and <strong>upperClub</strong> (or their duly appointed medical consultant) agree that
				transfer to the Home Country is more appropriate than transfer to the nearest qualified
				Hospital.
			</li>
		</ul>
	</div>





	<h2 (click)="toggleClass('8')" [ngClass]="{'open': show_description8}">PERSONAL TRAVEL DEVICES – up to US$ 500</h2>

	<div class="container" [ngClass]="{'show': show_description8}">
		<p>
			<strong>The Experience:</strong><br>
			Members contact <strong>upperClub</strong> leveraging our interactive contact tool, via preferred channel such
			as chat, voice or video, to submit required documentation. <strong>upperClub</strong> will offer members
			support to replace the personal item based on the <strong>upperClub</strong> policy.
		</p>
		<p>
			<strong>Terms and Conditions:</strong><br>
			Up to the amount stated for the value of, or repair to, any of the <strong>Covered Person’s</strong> <strong>Gadgets</strong>
			(not hired, loaned or entrusted to the <strong>Covered Person</strong>) purchased with the card associated with
			the <strong>upperClub</strong> platform, which are lost, stolen, damaged or destroyed. Cover is provided based
			on the amount the <strong>Covered Person</strong> paid for the <strong>Gadget</strong>(s) or the current recommended retail
			price whichever is the lower, excluding any credit charges, interest charges or coverage costs
			and allowing for wear, tear and depreciation.
		</p>
		<p>
			At <strong>upperClub</strong>’s discretion, <strong>upperClub</strong> may replace the Gadget with a refurbished item from
			one of <strong>upperClub</strong>’s dedicated suppliers.
		</p>
		<p>
			Conditions and Restrictions:
		</p>
		<p>
			<strong>upperClub</strong> will not cover <strong>gadgets</strong> which are:
		</p>
		<ul class="text-normal">
			<li>
				Left in an Unattended vehicle (other than a motor home, provided the <strong>gadgets</strong> are stored out of view), or
			</li>
			<li>
				Within checked-in luggage or in luggage compartments/racks not immediately adjacent to the
				<strong>Covered Person</strong> on any form of Public Transport (other than hand luggage that stays with the
				<strong>Covered Person</strong> at all times).	
			</li>
		</ul>
	</div>





	<h2 (click)="toggleClass('9')" [ngClass]="{'open': show_description9}">BEST PRICE GUARANTEE</h2>

	<div class="container" [ngClass]="{'show': show_description9}">
		<p>
			<strong>The Experience:</strong><br>
			Members contact <strong>upperClub</strong> leveraging our interactive contact tool, via preferred channel such
			as chat, voice or video, to submit required documentation/proof of lower fare.
		</p>
		<p>
			<strong>Terms and Conditions:</strong><br>
			<strong>upperClub</strong> members will enjoy Best-Price Guarantee when booking travel based on the
			agreements with <strong>upperClub</strong> travel service providers.
		</p>

		<ul class="number">
			<li>
				<strong>Price Guarantee for Air flight.</strong><br>
				In the event of a lower rate available in <strong>upperClub</strong> or on another country-based website within
				24 hours of booking with <strong>upperClub</strong>, upperClub will credit or refund the difference in price.
			</li>
			<li>
				<strong>Price Guarantee for Hotels.</strong><br>
				In the event of a lower rate available in <strong>upperClub</strong> or on another country-based website up to
				11:59 pm Pacific 48 hours after completing the hotel booking, <strong>upperClub</strong> will credit or refund the
				difference in price.
			</li>
		</ul>
		<p>
			Conditions and Restrictions:
		</p>
		<p>
			The trip must be completed as per booked itinerary through the mobile app or, if available,
			via the Website’s online redemption system to be eligible for refund or credit.
			Member must file a Price Guarantee application form through the mobile app within twenty-four
			(24) hours after the booking OR, for hotels, within forty-eight-(48) hours after completing the
			booking. The lower rate must be available for booking at the time of contact.
		</p>
		<p>
			Each credit is valid for one (1) year from month of issuance.
		</p>

		<p>
			Price Guarantee is available only for exact itinerary and fare matches included at the “Fly &amp; Stay
			Care” product.
		</p>
		<p>
			Price Guarantee applies only to prices both advertised and available to the public on an English
			and Spanish-language website. For example, it does not apply to rates offered on:
		</p>

		<ul class="point">
			<li>
				Membership program websites, corporate discounts or rates
			</li>
			<li>
				Group, charter, rewards program, incentive, meeting, convention, consolidator or interline prices
			</li>
			<li>
				Prices obtained via auction or similar process
			</li>
			<li>
				Prices available only by using a coupon or other promotion not offered to the general public.
			</li>
		</ul>

		<p>
			The lower rate may not come from a website where Member called to get the rate, or from an e-
			mail received. Additionally, the rate must be quoted, booked, and paid for in US dollars.
		</p>
		<p>
			All Price Guarantee requests, including receipts, are subject to verification by the Program
			Administrator. Program Administrator will not accept screenshots or other purported evidence of
			a lower price that cannot be independently confirmed by program personnel.
		</p>
		<p>
			<strong>novae care &amp; connect Inc. t / a upperClub Inc.</strong> will provide the <strong>Benefits</strong> described in this
			terms &amp; conditions as a result of acquiring <strong>upperClub</strong>. The subscriber&#39;s agreement is subject to
			all the terms, conditions, provisions and exclusions of this document, including the declaration,
			and all documentary evidence, <strong>Benefits</strong> chart and / or endorsements attached hereto.
		</p>
		<p>
			<strong>novae care &amp; connect Inc. t / a upperClub Inc.</strong> complying with the legal provisions, has
			acquired insurance policies where it acts as insured and beneficiary, with the faculty to transfer the coverage and <strong>Benefits</strong> to the holders of its membership, as well as to all those people linked
			to their service plans.
		</p>
		<p>
			Therefore, all communications, notifications, payment requirements and services included in this
			document will be directly transmitted and addressed through <strong>novae care &amp; connect Inc. t / a upperClub Inc.</strong>.
		</p>
		<p>
			Taking into account everything described above and for the purposes of this document it will be
			understood that <strong>novae care &amp; connect Inc. t / a upperClub Inc.</strong> will act as policyholder /
			insured and to such extent will transfer all protections and <strong>Benefits</strong> to related persons to its
			service plans.
		</p>
		<p>
			<strong>upperClub</strong>, provided by <strong>novae care &amp; connect Inc. t / a upperClub Inc.</strong> as the Master
			Policyholder with address in 601 Brickell Key, Suite 501, Miami, FL 33131 USA, enables the
			Coverage <strong>Benefits</strong> described in the following section. <strong>upperClub</strong> is underwritten 100% by
			Canopius, 4444 Syndicate at Lloyds, with unique market reference as B0524CSP18XXX6195.
		</p>
		<p>
			The Florida Surplus Lines Agent is Betsy L. Brougher with Licence # P037090 and located at
			212 W 10th St. #C400, Indianapolis, Indiana 46220.
		</p>
		<p>
			CHOICE OF LAW &amp; JURISDICTION: This contract of Insurance shall be governed by and
			construed in accordance with the law of the United States of America and each party agrees to
			submit to the exclusive jurisdiction of the courts of the United States of America as LMA 5020
			Service of Suit Clause and LMA5021 Applicable Law (USA).
		</p>
		<p>
			<strong>Benefits</strong> are subject to all of the following:
		</p>
		<p>
			All terms, conditions, provisions and exclusions of this document, including any applicable
			Exhibits, Schedules, and/or Endorsements.
		</p>
		<p>
			Current subscription to the <strong>upperClub</strong> &#39;App&#39;.
		</p>
		<p>
			Any enrollment associated fees, if applicable.
		</p>
		<p>
			Only new Trips taken after the coverage start date that the Member has been advised are
			covered.
		</p>
		<p>
			Words and terms in bold title case (other than those in titles and headings) shall have the
			meanings stated in Part VII - Definitions.
		</p>
		<p>
			ClickHelpNet, LLC has been appointed as the Claims Administrator. All communications,
			notices and payment of claims required under this cover shall be transmitted to and from the
			<strong>Covered Person</strong> through the Claims Administrator.
		</p>
		<p>
			<strong>DATE OF VALIDITY OF THE COVERAGE FOR A COVERED PERSON</strong><br>
			The coverage comes into effect at the time the <strong>Covered Person</strong> leaves their Country of Origin.
		</p>
		<p>
			<strong>TERRITORIAL VALIDITY</strong><br>
			The protections and <strong>Benefits</strong> provided by <strong>novae care &amp; connect Inc. t / a upperClub Inc.</strong> will
			be valid outside of the holder&#39;s country of residence, subject to product conditions.
		</p>
		<p>
			<strong>TERMINATION DATE OF COVERAGE</strong><br>
			Termination Date of Coverage for a <strong>Covered Person</strong> - Coverage ends on the earliest of the
			following:
		</p>
		<ul class="number">
			<li>The moment the <strong>Covered Person</strong> returns to their Home Country, or</li>
			<li>
				11:59 pm on the 120th day following the date the <strong>Covered Person</strong> departs his or her Home Country, or
			</li>
			<li>11:59 pm on the last day of the Membership Period, or</li>
			<li>The date the <strong>Covered Person</strong> no longer meets the Eligibility requirements stated herein</li>
		</ul>
		<p>
			<strong>FALSIFICATION AND FRAUD</strong><br>
			Any false statement, reluctance, concealment of truth or fraud in relation to any claim, or if any method or device is used by the owner or by any person acting on behalf of him, this service program will be null and void and all the claims submitted under it will be rejected.
		</p>
		<p>
			<strong>PROOF OF CLAIM</strong><br>
		</p>

		<ul class="text-capital">
			<li>
				The <strong>upperClub</strong> partner must communicate through alle, our interactive contact tool, to present
				the required documentation / Statements.
			</li>
			<li>
				Payment of Claims: All <strong>Benefits</strong> payable shall be paid to the <strong>Covered Person</strong> or, in case of
				death, to their respective assets.
			</li>
			<li>
				False Statement and Fraud: Coverage of a <strong>Covered Person</strong> will be null and void if, before or
				after a loss, it has concealed or misrepresented any significant fact or circumstance concerning
				the coverage or its purpose, or the interest the <strong>Covered Person</strong> has in she, or if the Covered
				Person commits fraud or gives false testimony in relation to the foregoing.
			</li>
		</ul>
		<p>
			<strong>ARBITRATION</strong><br>
			If any difference arises over the amount payable under this coverage (if liability is otherwise
			admitted), this difference should be referred to arbitration, according to the procedures of the
			London Court of International Arbitration. When any difference is derived to arbitration under
			this provision, any award shall be considered a condition precedent to any right of action
			against the Claims Administrator.
		</p>
		<p>
			<strong>EXTINCTIVE TERM</strong><br>
			The obligations arising from the contract expire 180 days after the end of their temporary validity
			in the event of coverage in international travel.
		</p>
		<p>
			<strong>SUBROGATION</strong><br>
			The <strong>Covered Person</strong> undertakes to cooperate with the Claims Administrator in the prosecution
			of any and all valid claims they may have against third parties arising out of any occurrence
			which results or may result in a loss payment by the Claims Administrator and to account for
			any amounts recovered on the basis that the Claims Administrator shall be entitled to recover
			first in full any sums paid by them before the <strong>Covered Person</strong> shares in any amount so
			recovered. Should the <strong>Covered Person</strong> fail to prosecute any valid claims against third parties
			and the Claims Administrator thereupon become liable to make payment under this cover, then
			the Claims Administrator shall be subrogated to all rights of the <strong>Covered Person</strong>. Any amount
			recovered by the Claims Administrator&gt; shall be used to pay the expenses of collection and
			reimbursement of <strong>upperClub</strong> for any amount that it may have paid or become liable to pay
			under this cover. Any remaining amounts shall be paid to the <strong>Covered Person</strong>.
		</p>


		
		<p><strong>RIGHT OF RECOVERY</strong></p>

		<p>In the event of overpayment of any claim hereunder because:</p>

		<ul class="number">
			<li>All or some of the expenses were not paid for by or on behalf of the <strong>Covered Person</strong> or were subsequently recovered by or on behalf of the <strong>Covered Person</strong>; or</li>
			<li>Any Relative of the <strong>Covered Person</strong>, whether or not that person is or was a <strong>Covered Person</strong>, is repaid for all or some of those expenses by a source other than <strong>upperClub</strong>; or</li>
			<li>All or some of the expenses were not Eligible Expenses; or</li>
			<li>All or some of the expenses were paid or reimbursed based on incorrect Benefit application, then the Claims Administrator has the right to recover the amount of overpayment from the <strong>Covered Person</strong> and/or the Hospital, <strong>Physician</strong> or other Medical Provider of services or supplies. The amount of the recovery is the difference between:</li>
		</ul>

		<ul class="text-normal">
			<li>The amount of expenses actually paid by the Claims Administrator; and</li>
			<li>The amount of <strong>Benefits</strong> which should have been paid by the Claims Administrator.</li>
		</ul>

		<p>If the <strong>Covered Person</strong> or the Hospital, <strong>Physician</strong> or other Medical Provider of services or supplies does not promptly make any such refund to the Claims Administrator, the Claims Administrator may, in addition to any other remedies available to them, either: (i). reduce the amount of any future claim that is otherwise eligible for payment hereunder, to the full extent of the refund due the Claims Administrator; or (ii) cancel the coverage provided to the <strong>Covered Person</strong> hereunder by giving thirty (30) days advance written notice in accordance with the Notice provision herein.</p>

		<p><strong>DOCTOR HELP</strong></p>

		<p>Within the services provided by <strong>novae care &amp; connect Inc. t / a upperClub Inc.</strong> in its developments is the assistance service provided by the Dr. Help system, so below we expose the terms and conditions operating in particular for said service.</p>

		<p><strong>USE</strong></p>

		<p><strong>novae care &amp; connect Inc. t / a upperClub Inc.</strong> ("Doctor Help" or "we") operates the system called Doctor Help that is found in mobile applications ("Sites") with links to these terms of use. We offer online health assistance services and mobile devices (the "Services") that allow our partners ("Partners") around the world to report their health history and request medical assistance from health professionals ("Providers") to obtain services and medical assistance (" Services ").</p>

		<p>By accessing and using the service, you agree to be bound by these terms and conditions and all other terms and policies that appear on the sites. If you do not wish to be bound by any of these conditions of use, you may not use the sites or the services.</p>

		<p><strong>DOCTOR HELP SERVICES</strong></p>

		<p>All the providers that provide services through Doctor Help are independent professionals exclusively responsible for the services that each one provides. Doctor Help does not practice medicine or any other licensed profession and does not interfere with the practice of medicine or any other profession with a provider's treatment license, each of which is responsible for their services and compliance with applicable requirements and according to the license. Neither Doctor Help nor any third party that promotes the services or provides you with this service will be responsible for any professional advice you obtain from a treatment provider through the Services.</p>

		<p><strong>THE CONTENT</strong></p>

		<p>None of the contents of the site (apart from the information that you receive from the Suppliers) or the first contact with the services in the form of contact included in the sites, should be considered as medical advice or an endorsement, representation or guarantee that any medication or treatment in particular is safe, appropriate or effective for you.</p>

		<p><strong>INFORMED CONSENT</strong></p>

		<ul class="text-capital">
			<li>The services included in Doctor Help correspond to the provision of health care services using interactive audio and video technology, in which the patient and the health professional are not in the same physical location of the applicant. During the service consultation with a treatment provider, the details of your health history and personal medical information may be discussed with you through the use of interactive video, audio or other telecommunications technology and your treatment provider who may practice a physical examination through these technologies.</li>
			<li>The services you receive from providers are not intended to replace a primary or permanent medical relationship. It is possible to form an ongoing treatment relationship with some treating providers. However, your initial visit with a treatment provider will begin as a consultation (for example, to determine the most appropriate treatment setting for you to receive care) and does not necessarily result in a continuing treatment relationship. You should seek <strong>Emergency</strong> help, or when recommended by a treatment provider, or when otherwise necessary follow-up care, and consult with your primary care physician and other health professionals as recommended.<br /> We can arrange for follow-up care, either through Doctor Help or another means. You will have direct access to customer services to track reactions to medications, side effects or other adverse events. Among the <strong>Benefits</strong> of our services are the best access to health and comfort professionals using the technological means available for this purpose. However, as with any health service, there are potential risks associated with the use of the services. These risks include, but are not limited to:</li>

			<ul class="text-normal">
				<li>In rare cases, the information transmitted may not be sufficient (for example, due to poor image resolution) to allow for appropriate health care decision making by the treatment provider;</li>
				<li>Delays in evaluation or treatment could occur due to failures of electronic equipment. If this happens, you can be contacted by phone or other means of communication.</li>
				<li>In rare cases, the lack of access to all your health records may result in adverse pharmacological effects or allergic reactions or other errors of judgment;</li>
				<li>Although the electronic systems we use will incorporate network protocols and software security to protect the privacy and security of health information, in rare cases, security protocols could fail, causing a violation of the personal medical information privacy.</li>
			</ul>

			<li>By accepting these conditions of use, it is acknowledged that you understand and agree with the following:</li>

			<ul class="text-normal">
				<li>You understand that it is possible to expect the anticipated <strong>Benefits</strong> of using the services in your care, but that the results can not be guaranteed or insured.</li>
				<li>You understand that the laws that protect the privacy and security of health information apply to services, and you have received notification from Doctor Help about privacy practices. Electronic communications are directed to your provider (s) in the treatment and their supervision through a secure encrypted video interface and electronic medical record.</li>
				<li>If the coverage of your membership does not include or is not sufficient to cover the service expenses in full, you may be totally or partially responsible for the payment.</li>
				<li>Your treatment provider may determine that the services are not appropriate for all or some of your treatment needs, and may therefore deny the provision of services to those through the Sites.</li>
			</ul>
			<li>You also have the ability to send written notes to therapists or other treatment or customer support providers using a secure messaging portal on the sites.</li>
		</ul>

		<p>The messages you send through the sites can be viewed by more than one agent or customer care and treatment provider and will normally be answered within 48 hours.</p>

		<p>You should not rely on the messaging of the sites if you need immediate attention from a treatment provider or other health professional. If you are experiencing a medical emergency, you should call your regular local <strong>Emergency</strong> line or go to the nearest emergency room.</p>

		<p>You understand and accept that messaging treatment with providers through the messaging portal does not result in a doctor-patient relationship, and does not on its own to treatment, diagnosis, therapy or medical advice.</p>

		<p><strong>MEDICAL PRIVACY</strong></p>

		<p><strong>novae care &amp; connect Inc. t / a upperClub Inc.</strong>, through Doctor Help, is required to comply with the privacy and health safety laws and maintain the information safeguarded to protect the security of your medical information; In addition, the information you provide to your treatment provider at the medical consultation or therapy session is legally confidential, except for certain legal exceptions.</p>

		<p>We dedicate considerable effort to ensure that your personal information is secure. The use of other personal health information is provided in our Privacy Policy.</p>

		<p>As part of providing you with the services, we may have to offer you certain communications, such as appointment reminders, service announcements and administrative messages. These communications are considered part of the services and your account. While secure electronic messaging is always preferred to unsafe email, under certain circumstances, email communication with personal information may take place between you and Doctor Help. <strong>novae care &amp; connect Inc. t / a upperClub Inc.</strong> can not guarantee the security or confidentiality of messages sent via email. Information regarding your care, including clinical notes and medical records, is stored on secure servers, encrypted and maintained by the administrator.</p>

		<p><strong>USE OF SERVICES FOR MINORS</strong></p>

		<p>The services provided by <strong>novae care &amp; connect Inc. t / a upperClub Inc.</strong> are available for use by minors, however the Member, for all users under the age of 18 must be the parent or legal guardian. If you register as the parent or legal guardian on behalf of a minor, you will be fully responsible for compliance with these terms of use.</p>

		<p><strong>RIGHTS OF ACCESS</strong></p>

		<p>We hereby grant you a non-exclusive, limited, non-transferable right to access the applications and use the Services solely for your non-commercial personal use and only as set forth in these terms and conditions and any separate agreement you may have contracted. with us ("Access rights").</p>

		<p>We reserve the right, at our sole discretion, to deny or suspend the use of the Sites or the Services for any person for any reason. You agree that you will not, and will not try to:</p>

		<ul class="point">
			<li>(A) impersonate another person or entity, or otherwise forge your association to any person or entity;</li>
			<li>(B) use the Site or the Services to violate any local state, national or international law;</li>
			<li>(C) reverse engineer, disassemble, decompile or translate any software or other components of the Site or the Services;</li>
			<li>(D) distribute viruses or any other harmful computer code through the Site or</li>
			<li>(E) otherwise use the services or the Sites and in no way exceed the scope of use previously granted.</li>
		</ul>

		<p>In addition, it undertakes to abstain from abusive language when communicating with the providers through the modules and to refrain from contacting the service providers outside the application modules. <strong>novae care &amp; connect Inc. t / a upperClub Inc.</strong> is not responsible for any interaction with suppliers that is not carried out through the established media.</p>

		<p><strong>MODIFICATIONS</strong></p>

		<p>We reserve the right to change, add or remove portions of these terms and conditions at any time. Your continued use of the sites and / or Services following notification of such changes will indicate that you acknowledge such changes and agree to be bound by the revised Terms and Conditions, including such changes.</p>

		<p><strong>LIMITATION OF WARRANTY</strong></p>

		<p>You expressly agree that: USE OR SERVICES ARE AT YOUR OWN RISK. BOTH, the sites and services are provided "AS IS" AND "AS AVAILABLE". <strong>novae care &amp; connect Inc. t / a upperClub Inc.</strong> EXPRESSES ALL WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, WARRANTIES OF MERCHANTABILITY, FITNESS FOR A USE OR PURPOSE, NON-INFRINGEMENT, TITLE, OPERATING , CONDITION, ENJOYMENT AND VALUE, ACCURACY OF DATA AND SYSTEM OF INTEGRATION. You acknowledge and agree that <strong>novae care &amp; connect Inc. t / a upperClub Inc.</strong> does not provide medical advice, diagnosis or treatment, and is strictly a technology and infrastructure platform for connecting users with providers of goods, services or treatment. , including physicians and other providers in the <strong>novae care &amp; connect Inc. t / a upperClub Inc.</strong> You acknowledge and agree that the treating providers using the sites are solely responsible and will have full authority, responsibility, supervision and control over the provision of all medical services, advice, instructions, treatment decisions, and other professional care services. the health carried out, and that all diagnoses, treatments, procedures and other professional medical care services that will be identified and carried out only by or under the supervision of the treating providers, at their discretion, that they deem appropriate.</p>

		<p><strong>LIMITATION OF LIABILITY.</strong></p>

		<p>YOU UNDERSTAND THAT THE EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL <strong>novae care &amp; connect Inc. t / a upperClub Inc.</strong> or its officers, employees, directors, matrices, subsidiaries, affiliates, agents or licensees BE LIABLE FOR INDIRECT, INCIDENTAL, OR CONSEQUENTIAL DAMAGES, SPECIAL, CONSEQUENTIAL OR EXEMPLARY, INCLUDING, BUT NOT LIMITED TO, LOSS OF INCOME, PROFITS, CUSTOMER, USE, DATA OR OTHER INTANGIBLE LOSS FROM OR RELATED TO THE USE OF THE SITE OR THE SERVICES, regardless of whether such damages are based on in contract, tort (including negligence and strict liability), guarantee, LAW OR OTHER. To the extent that, perhaps, as a matter of applicable law, we deny any implied warranties or limit your liabilities, the scope and duration of such warranty and the extent of our liability will be the minimum permitted under such applicable law.</p>

		<p><strong>COMPENSATION</strong></p>

		<p>You agree to indemnify, defend and hold <strong>novae care &amp; connect Inc. t / a upperClub Inc.</strong> and doctor help understood as a product of <strong>novae care &amp; connect Inc. t / a upperClub Inc.</strong> free of liability and its executives, directors, employees, agents, subsidiaries, affiliates, licensees and suppliers, of and against any claim, actions, demands, responsibilities and settlements, including, without limitation, legal costs and accounting expenses ("Claims"), as a result of, or that are allegedly the result of, your violation of these terms and conditions. In addition, it undertakes to indemnify, defend and hold harmless its supplier (s) against any claim by third parties arising from the lack of adherence to the advice or recommendation (s) of said treatment provider.</p>

		<p><strong>GEOGRAPHICAL RESTRICTIONS</strong></p>

		<p><strong>novae care &amp; connect Inc. t / a upperClub Inc.</strong>&nbsp;does not guarantee that all products, services and / or material described, or services available through the upperClub application are appropriate or available for use in some locations.</p>
		<p><strong>DISCLOSURES OF DOCTOR HELP</strong></p>

		<p>All medical personnel involved in upperClub have professional licenses issued by the professional licensing boards in the places where they practice, with the title of doctor of medicine and have received post-doctoral training. You can report a complaint regarding the services provided by a treatment provider by contacting the professional licensing board at the place where the services were received. In a professional relationship, sexual intimacy is never appropriate and the board must be informed that the licenses, registrations, or certification of the licensee.</p>

		<p><strong>OTHERS</strong></p>

		<p>It is your understanding that by accepting these terms and conditions and / or any other form that is presented to you, you accept these terms and that such action constitutes a legal signature.</p>

		<p>You agree that we may send notices, accesses, or communications related to the services (collectively, "Communications") through electronic means, including, but not limited to: (1) by email, using the address you provide to us. provided during registration, or (2) by posting communications on the Sites and also direct notifications to the application.</p>

		<p>The delivery of any of our Communications is effective when it is sent by us, regardless of whether it is read and accepted once received. You may withdraw your consent to receive communications by canceling or suspending the use of the Services.</p>

		<p>No waiver of any term or condition set forth in these terms and conditions shall be deemed a subsequent or continued waiver of such terms or conditions or a waiver of any other term or condition, and the fact that the Company may protect a right or provision in under these Terms and Conditions.</p>

		<p>If any provision of these terms and conditions are considered by a competent court as invalid, illegal or unenforceable for any reason, such provision will be eliminated or limited to the minimum extent such that the remaining provisions of the conditions of use will continue in full effect.&nbsp;<strong>novae care &amp; connect Inc. t / a upperClub Inc.</strong> devotes considerable effort to the optimization of signal strength and diagnostic deficiencies, but is not responsible for the Internet or bandwidth and signal data of your device. Report any violation of these Terms and Conditions through the established contact means. If you believe in good faith that the materials that appear on these sites infringe your copyright, you (or your agent) may send us a notice requesting that the material be removed, or access to it. In addition, if you believe in good faith that a notice of copyright violation has been improperly filed against you, you may send a response notice. Notices and counter-notices must comply with the mandatory requirements established by law.</p>

		<p><strong>Accident:</strong> A sudden, unintentional and unexpected occurrence caused by external, visible means and resulting in physical <strong>Injury</strong> to the <strong>Covered Person</strong>. The cause or one of the causes of such <strong>Accident</strong> is external to the <strong>Covered Person's</strong> own body and occurs beyond the <strong>Covered Person's</strong> control.</p>

		<p><strong>Accidental Death: </strong>Death of the <strong>Covered Person</strong> resulting from an <strong>Accident</strong>.</p>

		<p><strong>Act of Terrorism:</strong></p>

		<p>For Section I and Section III: An act, including but not limited to the use of force or violence and/or the threat thereof, of any person or group(s) of persons, whether acting alone or on behalf of or in connection with any organization(s) or government(s) committed for political, religious, ideological or similar purposes including the intention to influence any government and/or to put the public, or any section of the public, in fear.</p>

		<p>For Section II: An unlawful act, including the use of force or violence, of any person or group(s) of persons, whether acting alone or on behalf of or in connection with any organization(s), committed for political, religious or ideological purposes including the intention to influence any government and/or to put the public in fear for such purposes.</p>

		<p><strong>AIDS:</strong> Acquired Immune Deficiency Syndrome as that term is defined by the United States Centers for Disease Control.</p>

		<p><strong>ARC: </strong><strong>AIDS </strong>Related Complex as that term is defined by the United States Centers for Disease Control.</p>

		<p><strong>Amateur Athletics:</strong> A sport or other athletic activity that is organized and/or sanctioned, involving regular or scheduled practices and/or regular or scheduled games. This definition does not include athletic activities that are non-contact and engaged in by a <strong>Covered Person</strong> solely for recreational, entertainment or fitness purposes and not for wage, reward or profit.</p>

		<p><strong>Benefits:</strong> The <strong>Eligible Expenses</strong> which may be paid under this cover.</p>

		<p><strong>Claims Administrator:</strong> The entity stated as such at the start of this Evidence of Cover.</p>

		<p><strong>Claims Excess:</strong> The Dollar amount of <strong>Eligible Expenses</strong> specified in the cover that the <strong>Covered Person</strong> must pay before <strong>Benefits</strong> are paid hereunder.</p>

		<p><strong>Common Carrier: </strong>A licensed mode of Public Transportation.</p>

		<p><strong>Consultant(s);</strong> The consultant appointed by the <strong>Claims Administrator</strong>.</p>

		<p><strong>Contact Sports: </strong>A sport or other athletic activity that necessarily involves physical contact with opposing players as part of normal play. <strong>Contact Sports</strong> include, but are not limited to, American football, boxing, ice hockey, rugby, soccer, and wrestling.</p>

		<p><strong>Covered Person:</strong> A person who meets the Eligibility requirements stated in Part 1 &ndash; Coverage Provisions.</p>

		<p><strong>Custodial Care:</strong> That type of care or service, wherever furnished and by whatever name called, that is designed primarily to assist a <strong>Covered Person </strong>in performing the activities of <strong>Daily Living. Custodial Care </strong>also includes non-acute care for the comatose, semi-comatose, paralyzed or mentally incompetent patients until they are fit to return home.</p>

		<p><strong>Daily Living:</strong> A twenty-four (24) hour period during which a <strong>Covered Person </strong>engages in normal daily activities including but not limited to eating, drinking and washing.</p>

		<p><strong>Delivery:</strong> Procedures concerning childbirth.</p>

		<p><strong>Dental Treatment:</strong> Treatment of the teeth and gums.</p>

		<p><strong>Dependent Child(ren):</strong> The individual <strong>Member&rsquo;s</strong> child who meets all of the following conditions:</p>

		<ul class="text-normal">
			<li>is unmarried;</li>
			<li>is a natural child, legally adopted child, or a child who has been placed under the legal guardianship of the <strong>Member</strong>;</li>
			<li>has not yet reached their 19th birthday. The age requirement is waived if the child is at least 19 years of age and not yet 25 years of age, is dependent on the individual <strong>Member</strong> for support, and is a <strong>Full-time Student</strong> who resides with the individual <strong>Member</strong>. The age requirement is also waived for any mentally retarded or physically handicapped child who is incapable of self-sustaining maintenance, provided the child suffered such incapacity prior to attaining 19 years of age. Proof of incapacity must be furnished to the <strong>Claims Administrator</strong>, and additional proof may be required from time to time.</li>
		</ul>

		<p>The term <strong>Dependent Child(ren)</strong> does not include the following: a person who is emancipated from the <strong>Member</strong>; any person who is on active duty with any military, and/or any person who is covered hereunder as an individual <strong>Member</strong>.</p>

		<p><strong>Dependent Parent(s}:</strong> The natural or adopted mother and/or father of the <strong>Member</strong> who is wholly dependent on the <strong>Member</strong> for support.</p>

		<p><strong>Durable Medical Equipment:</strong> A standard basic hospital bed and/or a standard basic wheelchair.</p>
		<p><strong>Educational or Rehabilitative Care:</strong> Care for restoration (by education or training) of one's ability to function in a normal or near normal manner following an <strong>Illness</strong> or <strong>Injury</strong>. This type of care includes, but is not limited to, vocational or occupational therapy and speech therapy.</p>

		<p><strong>Eligible Expenses:</strong> Expenses for services and supplies which are covered under this cover.</p>

		<p><strong>Eligible Spouse:</strong> An individual who is married to the <strong>Member</strong>. The marriage must have met all of the requirements of a valid marriage contract in the jurisdiction of the marriage of the individuals. The term <strong>Eligible Spouse</strong> does not include the following: a person who is legally separated or divorced from the <strong>Member</strong>, any person who is on active duty with any military, and/or any person who is covered hereunder as an individual <strong>Member</strong>.</p>

		<p><strong>Emergency:</strong> A medical condition manifesting itself by acute signs or symptoms which could reasonably result in placing the <strong>Covered Person's</strong> life in danger if medical attention is not provided within twenty-four (24) hours.</p>

		<p><strong>Emergency Room:</strong> That part of a <strong>Hospital</strong> designated for the immediate care of <strong>Emergency</strong> medical conditions.</p>

		<p><strong>Enforced Political Evacuation:</strong> The evacuation of <strong>Covered Person (s)</strong> from the Country in which they are visiting/staying as a result of an <strong>Evacuation Advisory</strong> triggered by a <strong>Political Event</strong> for travel being any journey outside of the <strong>Covered Person`s</strong> Home Country.</p>

		<p><strong>Evacuation Advisory:</strong> An instruction issued to the <strong>Covered Person</strong> by a civil or military authority of the <strong>Covered Person</strong>&rsquo;s Home Country to the effect that the <strong>Covered Person</strong> should evacuate from the country in which the <strong>Covered Person</strong> is situated.</p>

		<p><strong>Extended Care Facility:</strong> An institution, or a distinct part of an institution, which is licensed as a <strong>Hospital</strong>, Extended Care Facility or rehabilitation facility by the jurisdiction in which it operates; and is regularly engaged in providing twenty four (24) hour skilled nursing care under the regular supervision of a <strong>Physician</strong> and the direct supervision of a <strong>Registered Nurse</strong>; and maintains a daily record on each patient; and provides each patient with a planned program of observation prescribed by a <strong>Physician</strong>; and provides each patient with active treatment of an <strong>Illness </strong>or <strong>Injury. Extended Care Facility </strong>does not include a facility primarily for rest, the aged, <strong>Substance Abuse</strong> treatment, <strong>Custodial Care</strong>, nursing care or for care of <strong>Mental Health Disorders</strong> or the mentally incompetent.</p>

		<p><strong>Family:</strong> All <strong>Relatives</strong> of a <strong>Member</strong>.</p>

		<p><strong>Full-time Student:</strong> A person who is enrolled in and regularly attends an accredited college or university or other educational institution, but not including colleges, universities or other educational institutions operated primarily via the internet, for the minimum number of credit hours required by the accredited college or university or other educational institution in order to maintain Full-time Student status.</p>

		<p><strong>Gadgets:</strong> Mobile/smart phones, tablet computers, laptops, computers, smart watches, satellite navigation systems (GPS), Personal Digital Assistants (PDAs), games consoles (including handheld consoles) and all accessories for these items.</p>

		<p><strong>HIV+:</strong> Laboratory evidence defined by the <strong>United States</strong> Centers for Disease Control as being positive.</p>

		<p><strong>Home Country:</strong> The country where the <strong>Covered Person </strong>resides permanently.</p>

		<p><strong>Hospital:</strong> A place that is legally licensed for the purpose of providing medical or surgical care and treatment to sick or injured people in the country in which it is located. <strong>Hospital</strong> does not mean a long-term care facility, spa, hydro clinic, sanatorium, nursing home for the aged or any other facility which is not a Hospital.</p>

		<p><strong>Host Country:</strong> The country being visited by the <strong>Covered Person</strong>, or where the <strong>Covered Person </strong>resides temporarily. <strong>Host Country </strong>does not include the <strong>Covered Person&rsquo;s Home Country</strong>.</p>

		<p><strong>Illness:</strong> A sickness, disorder, pathology, abnormality, ailment, disease or any other medical, physical or health condition. <strong>Illness</strong> does not include learning disabilities, attitudinal disorders or disciplinary problems.</p>

		<p><strong>Injury:</strong> Identifiable physical harm to the body caused by an <strong>Accident</strong> that requires medical treatment.</p>

		<p><strong>Inpatient:</strong> A patient who occupies a <strong>Hospital</strong> bed for more than twenty-four (24) hours for medical treatment and whose admission was recommended by a <strong>Physician</strong>.</p>

		<p><strong>Intensive Care Unit:</strong> A Cardiac Care Unit or other unit or area of a <strong>Hospital</strong> that meets the required standards of the Joint Commission on Accreditation of Hospitals for Special Care Units.</p>

		<p><strong>Investigational, Experimental or for Research Purposes:</strong> Terms used to describe procedures, services or supplies that are by nature or composition, or are used or applied, in a way which deviates from generally accepted standards of current medical practice.</p>
		<p><strong>Kidnap and Ransom:</strong> Unlawful detention of a <strong>Covered Person</strong> against their will, whether hijacked, kidnapped or detained, by any person or persons not known to him/her.</p>

		<p><strong>Medical Provider:</strong> A <strong>Hospital, Physician</strong> or other person or organization which provides medical services and/or supplies.</p>

		
		<p><strong>Medically Necessary:</strong> A service or supply which is necessary and appropriate for the diagnosis or treatment of an <strong>Illness </strong>or <strong>Injury</strong> based on generally accepted current medical practice as determined by the <strong>Claims Administrator</strong>. A service or supply will not be considered <strong>Medically Necessary</strong> if it is provided only as a convenience to the <strong>Covered Person </strong>or <strong>Medical Provider</strong>, and/or is not appropriate for the <strong>Covered Person's</strong> diagnosis or symptoms, and/or exceeds in scope, duration or intensity that level of care which is needed to provide safe, adequate and appropriate diagnosis or treatment of an <strong>Illness</strong> or <strong>Injury</strong>.</p>

		<p><strong>Member:</strong> An individual who meets the Eligibility requirements stated under Part I but who is not an <strong>Eligible Spouse, Dependent Child </strong>or <strong>Dependent Parent</strong>.</p>

		<p><strong>Mental Health Disorder:</strong> A mental or emotional disease or disorder which generally denotes a disease of the brain with predominant behavioral symptoms; or a disease of the mind or personality, evidenced by abnormal behavior; or a disorder of conduct evidenced by socially deviant behavior. <strong>Mental Health Disorders</strong> include but are not limited to: psychosis, those psychiatric <strong>Illnesses</strong> listed in the current edition of the diagnostic and Statistical Manual for Mental <strong>Disorders</strong> of the American Psychiatric Association.</p>

		<p><strong>Newborns:</strong> Babies under the age of one month.</p>

		<p><strong>Outpatient:</strong> A <strong>Covered Person</strong> who receives <strong>Medically Necessary</strong> treatment by a <strong>Physician</strong> for <strong>Injury</strong> or <strong>Illness</strong> that does not require overnight stay in a <strong>Hospital</strong>.</p>

		<p><strong>Physician:</strong> A doctor of Medicine (MD), doctor of Dental <strong>Surgery</strong> (DDS), doctor of Dental Medicine (DDM) or a licensed Physical Therapist or Physiotherapist. <strong>Physician</strong> does not include a doctor of Chiropractic (DC), a doctor of Osteopathy (DO), a doctor of Psychology (Ph.D.), a doctor of Psychiatry (Psy.D.) or any other degree or designation. A <strong>Physician </strong>must be currently licensed by the jurisdiction in which the services are provided, and the services provided must be within the scope of that license. A <strong>Physician </strong>must be a person other than the <strong>Covered Person</strong>, the <strong>Covered Person</strong>'s Relative, or one who ordinarily resides with the <strong>Covered Person</strong>.</p>

		<p><strong>Political Event: </strong>means an incident that may lead to a loss arising out of an:</p>

		<p><strong>Act of Terrorism</strong></p>

		<p><strong>"Sabotage".</strong>Sabotage shall mean wilful physical damage or destruction perpetrated for political reasons by known or unknown person(s).</p>

		<p><strong>"Riots".</strong>Riots shall mean any act committed in the course of a disturbance of the public peace (where such disturbance is motivated by political reasons) by any person taking part together with others in such disturbance or any act of any lawfully constituted authority for the purpose of suppressing or minimizing the consequence of such act.</p>

		<p><strong>"Strikes".</strong> Strikes shall mean any wilful act of any striker or locked-out worker in the furtherance of a strike or in resistance to a lock-out or any act of any lawfully constituted authority for the purpose of suppressing or minimizing the consequence of such act.</p>

		<p><strong>"Civil Commotion".</strong> Civil Commotion shall mean the same as Riots as defined in this Cover.</p>

		<p><strong>"Malicious Damage".</strong> Malicious Damage shall mean all physical loss or physical damage resulting directly from an act(s) by anyone during a disturbance of the public peace where such malicious act is perpetrated for political reasons by known or unknown person(s).</p>
		<p><strong>"Insurrection, Revolution and Rebellion".</strong> Insurrection, Revolution and Rebellion shall mean a deliberate, organized and open resistance, by force and arms, to the laws or operations of a sovereign government, committed by its citizens or subjects and/or a rising against a sovereign government or other authority.</p>

		<p><strong>"Mutiny".</strong> Mutiny shall mean a wilful resistance by members of legally armed or peace-keeping forces to a superior officer.</p>

		<p><strong>"Coup d&rsquo;&eacute;tat".</strong> Coup d&rsquo;&eacute;tat shall mean the sudden, violent and illegal overthrow of a sovereign government or any attempt at such overthrow.</p>

		<p><strong>"Civil War".</strong> Civil War shall mean an internecine war, or a war carried on between or among opposing citizens of the same country or nation.</p>

		<p><strong>Pre-existing Condition:</strong> (1) Any condition for which medical advice, diagnosis, care, or treatment (includes receiving services and supplies, consultations, diagnostic tests or prescription medicines) was recommended or received during the two (2) years immediately preceding the Effective Date of Coverage for any covered <strong>Trip</strong>;</p>

		<p>(2) condition that had manifested itself in such a manner that would have caused a reasonably prudent person to seek medical advice, diagnosis, care, or treatment (includes receiving services and supplies, consultations, diagnostic tests or prescription medicines) within the two (2) years immediately preceding the Effective Date of Coverage for any covered <strong>Trip</strong>;</p>

		<p>(3) <strong>Injury, Illness</strong>, disease, or other physical, medical, mental, or nervous conditions, disorder or ailment (whether known or unknown) that, with reasonable medical certainty, existed within the two (2) years immediately preceding the Effective Date of Coverage for any covered <strong>Trip</strong>.</p>

		<p><strong>Pregnancy:</strong> The physical condition of being pregnant.</p>

		<p><strong>Principal Residence:</strong> The location where the <strong>Covered Person</strong> ordinarily resides, not including locations in the <strong>Host Country</strong>.</p>

		<p><strong>Professional Sports:</strong> A sporting activity undertaken for wage, reward or profit.</p>

		<p><strong>Proof of Claim:</strong> A completed and signed Claimant's Statement and Authorization form, together with any/all required attachments, original receipts for any expenses which have already been paid by or on behalf of the <strong>Covered Person</strong>, and any other documentation that is deemed necessary by the <strong>Claims Administrator</strong>. For claims under Section I the original itemized bills must be from <strong>Physicians, Hospitals,</strong> and other <strong>Medical Providers</strong>.</p>

		<p><strong>Public Transport:</strong> any type of transport which conveys members of the public including, but not limited to, coach, bus, train and aircraft.</p>

		<p><strong>Registered Nurse:</strong> A graduate nurse who has been registered or licensed to practice by the local authority Board of Nurse Examiners or any other authority, and who is legally entitled to place the letters "RN" after his or her name.</p>

		<p><strong>Relative:</strong> Biological or stepparent or grandparent; biological or stepchild or grandchild; <strong>Eligible Spouse</strong>; biological or stepsibling; parent, children, or sibling in law; aunt, uncle or cousin; fianc&eacute; or betrothed individual.</p>
		<p><strong>Routine Physical Exam:</strong> Examination of the physical body by a <strong>Physician for </strong>preventative or informative purposes only, and not for the diagnosis or treatment of any condition.</p>

		<p><strong>Scheduled Trip:</strong> A <strong>Trip</strong> which has been booked in advance.</p>

		<p><strong>Sexually Transmitted Diseases:</strong> Syphilis, gonorrhea, lymphogranuloma venereum, chancroid, granuloma inguinale, chlamydiosis, pelvic inflammatory disease, trichomoniasis, genital candidiasis, genital herpes, genital warts, amebiasis, viral hepatitis, scabies, crab lice, cervical dysplasia, and bacterial vaginitis.</p>
		<p><strong>Substance Abuse:</strong> Alcohol, drug or chemical abuse, overuse or dependency.</p>
		<p><strong>Surgery:</strong> An invasive diagnostic procedure, or the treatment of <strong>Illness</strong> or <strong>Injury</strong> by manual or instrumental operations performed by a <strong>Physician</strong> while the patient is under general or local anesthesia.</p>
		<p><strong>Trip:</strong> The period of time within the Membership Period beginning on the Effective Date of Coverage for a <strong>Covered Person</strong> and ending on the Termination Date of Coverage for a <strong>Covered Person</strong> as Part 1 &ndash; Coverage Provisions.</p>
		<p><strong>Unattended:</strong> Not in the <strong>Member&rsquo;s</strong> direct sight and control.</p>

		<p><strong>Usual, Reasonable and Customary:</strong> The most common charge for similar services, medicines or supplies within the area in which the charge is incurred, so long as those charges are reasonable. What is defined as <strong>Usual, Reasonable and Customary</strong> charges will be determined by the&nbsp;<strong>Claims Administrator</strong>. In determining whether a charge is&nbsp;<strong>Usual, Reasonable and Customary</strong>, the&nbsp;<strong>Claims Administrator</strong>&nbsp;may consider one or more of the following factors: the level of skill, extent of training, and experience required to perform the procedure or service; the length of time required to perform the procedure or services as compared to the length of time required to perform other similar services; the severity or nature of the&nbsp;<strong>Illness</strong>&nbsp;or&nbsp;<strong>Injury</strong>&nbsp;being treated; the amount charged for the same or comparable services, medicines or supplies in the locality; the amount charged for the same or comparable services, medicines or supplies in other parts of the country; the cost to the&nbsp;<strong>Medical Provider</strong>&nbsp;of providing the service, medicine or supply; such other factors as the&nbsp;<strong>Claims Administrator</strong>&nbsp;in the reasonable exercise of discretion, determine are appropriate.</p>

		<p>Eligibility - The following individuals are eligible for <strong>Benefits </strong>under this cover for up to 120 days maximum per <strong>Trip</strong>:</p>

		<ul class="text-normal">
			<li>Individuals who hold valid extensions of Corporate or Business cards issued by upperClub and have joined the upperClub program when a loss occurs</li>
			<li>Individual cardholders who have active cards and have joined the upperClub program when a loss occurs; and the following:</li>
			<ul class="number-roman">
				<li>Their <strong>Eligible Spouse</strong>; and</li>
				<li>Their <strong>Dependent Child(ren)</strong> who are at least 14 days old; and</li>
				<li>Their <strong>Dependent Parents</strong> each of which is a <strong>Covered Person</strong>.</li>
			</ul>
		</ul>

		<p>Membership Period - This cover becomes effective and terminates on the dates and at the times advised to the <strong>Member</strong> by email. This cover can be renewed for subsequent periods subject to agreement of <strong>upperClub</strong>. This cover can be cancelled by the <strong>Member</strong> by giving not less than 60 days advance written notice to <strong>upperClub </strong>at the start of this Evidence of Cover. This cover can be cancelled by <strong>upperClub</strong> by giving not less than 60 days advance written notice to the <strong>Member</strong>. In the event this cover is so cancelled by either party, or is not renewed at any anniversary, coverage with respect to <strong>upperClub <strong>Covered Person</strong>s</strong> shall terminate as of the date of cancellation or non-renewal. Notwithstanding the forgoing, <strong>upperClub</strong> may cancel this cover any time in accordance with Part VI, General Conditions and Conditions Precedent, of this cover.</p>

		<p>Effective Date of Coverage for a <strong>Covered Person</strong>- Coverage becomes effective on the moment the <strong>Covered Person</strong> departs from their <strong>Home Country</strong>.</p>

		<p>Termination Date of Coverage for a <strong>Covered Person</strong> - Coverage ends on the earliest of the following:</p>

		<ul class="number">
			<li>The moment the <strong>Covered Person</strong> returns to their <strong>Home Country</strong>, or</li>
			<li>11:59 pm on the 120th day following the date the <strong>Covered Person</strong> departs his or her <strong>Home Country</strong>, or</li>
			<li>11:59 pm on the last day of the Membership Period, or</li>
			<li>The date the <strong>Covered Person </strong>no longer meets the Eligibility requirements stated herein.</li>
		</ul>


	</div>

</div>
